import React from 'react';

export default class QuestionPagination extends React.Component<any, any> {

  constructor(props) {
    super(props);
  
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  callback = (i) => {

  }

  renderQuestionList = (calIndex, total, status) => {
    if (status === 'FINISH') {
      calIndex = total;
    }

    let element = [];
    const from = 0;
    const to = total;

    for (let i = from; i < to; i++) {
      // if (i < total) {
        // active
        if (calIndex === i) {
          // inactive
            element.push(<a key={`item-${i}`} className={ 'step-active' }>{i + 1}
          </a>);
        } else if (calIndex > i) {
          // inactive
          element.push(<a key={`item-${i}`} className={ 'step'} onClick={() => this.callback(i)}>{i + 1}
          </a>);
        } else {
          element.push(<a key={`item-${i}`} className={ 'step'} onClick={() => this.callback(i)}>{i + 1}
            <i className="fas fa-lock icon-lock"></i>
          </a>);
        }
      // }
    }

    // push finish
    element.push(<div key={`item-FINISH`} style={{ position: 'relative', display: 'inline-block' }}>
      <div style={{ position: 'absolute', top: '-20px' }} className={`grid-icon size-30 icon-finish ${ status !== 'FINISH' ? "opacity-5" : ""}`}></div>
    </div>)

    return element;
  }

  render() {
    const { index, total, status } = this.props;
    return (
      <>
        { this.renderQuestionList(index, total, status) }
      </>
    );
  }
}